var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.353,1.668H10.686c-5.06.006-9.161,4.107-9.167,9.167v25.667c.006,5.06,4.107,9.161,9.167,9.167h25.667c5.06-.006,9.161-4.107,9.167-9.167V10.834c-.006-5.06-4.107-9.161-9.167-9.167ZM37.252,29.765l-8.626,8.626h0c-2.818,2.818-7.387,2.819-10.205,0,0,0,0,0,0,0l-8.623-8.626-.058-.06c-.948-.931-.962-2.454-.032-3.402.931-.948,2.454-.962,3.402-.032.03.03.06.061.089.092l7.921,7.921-.017-25.05c0-1.328,1.077-2.405,2.405-2.405s2.405,1.077,2.405,2.405l.017,25.048,7.921-7.919c.923-.956,2.446-.982,3.401-.059s.982,2.446.059,3.401c-.019.02-.039.04-.059.059h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.8fb51fec945dc8b5bf0775e588d67d65.svg";
export { ForwardRef as ReactComponent };